import { useQuery } from "@tanstack/react-query"
import { fetchGivingPerson } from "../queries"
import { Heading } from "@planningcenter/doxy-web"
import { AlertMessage, Loading } from "source/shared/components"
import { PreferredEmailAddressSelector } from "./components/PreferredEmailAddressSelector"
import { SendsReceiptsSelector } from "./components/SendsReceiptsSelector"
import { css } from "@emotion/react"

export default function Notifications() {
  const {
    data: givingPersonNotificationsAttributes,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["GivingPerson"],
    queryFn: () => fetchGivingPerson(),
  })

  return (
    <section>
      <div className="d-n d-b@md mb-2">
        <Heading level={2} text="Notifications" />
      </div>
      {isError ? (
        <AlertMessage type="error" icon="general#exclamation-triangle">
          Something went wrong. Please try again.
        </AlertMessage>
      ) : isLoading ? (
        <Loading message="Loading" />
      ) : (
        givingPersonNotificationsAttributes && (
          <div
            className="p-2"
            css={css`
              border: 1px solid var(--color-static-gray93);
              border-radius: 8px;
            `}
          >
            <div className="d-n@md mb-2">
              <Heading level={2} text="Notifications" />
            </div>
            <div className="d-f fd-c g-3">
              <PreferredEmailAddressSelector
                preferredEmailAddress={
                  givingPersonNotificationsAttributes.giving_preferred_email_address
                }
                emailAddresses={
                  givingPersonNotificationsAttributes.email_addresses
                }
              />
              <SendsReceiptsSelector
                value={givingPersonNotificationsAttributes.sends_receipts}
              />
            </div>
          </div>
        )
      )}
    </section>
  )
}
